<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>계약 통계</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>계약 통계</h2>
        <div class="depLink">
          <button type="button" title="메뉴"><span>계약 통계</span></button>
          <ul>
            <li>
              <router-link to="/contactpoint"
                ><span>알아두실 사항</span></router-link
              >
            </li>
            <li>
              <router-link to="/sbcpInpInqNdPolOtpt"
                ><span>청약 입력/조회 및 증권출력</span></router-link
              >
            </li>
            <li>
              <router-link to="/subsChangeForm"
                ><span>증권 간략 정정</span></router-link
              >
            </li>
            <li>
              <router-link to="/unpaidList"><span>미납조회</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="tabBtn">
          <a class="active"><span>월별 계약현황</span></a>
          <router-link to="/staItem"><span>품목별 계약현황</span></router-link>
          <router-link to="/staLoc"><span>지역별 계약현황</span></router-link>
        </div>

        <div class="sortWrap type2">
          <dl class="mgr20">
            <dt class="w72">발생월</dt>
            <dd>
              <div class="inpDate w488">
                <input
                  type="text"
                  v-model="I_FR_YM"
                  title="검색 시작일"
                  maxlength="6"
                  size="6"
                  @change="onChangeInpdt"
                  @keydown.enter="keydownHandler"
                  @keyup="StartKeyUpHandler"
                />
                <span>~</span>
                <input
                  type="text"
                  v-model="I_TO_YM"
                  title="검색 종료일"
                  maxlength="6"
                  size="6"
                  @change="onChangeInpdt"
                  @keydown.enter="keydownHandler"
                  @keyup="EndKeyUpHandler"
                />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>보험품종</dt>
            <dd>
              <div class="inpSlt">
                <button type="button" class="sltBtn" title="조건 선택">
                  <span>전체</span>
                </button>
                <ul>
                  <li v-for="(item, index) in state.getIprodType" :key="index">
                    <button
                      type="button"
                      class="sltOpt"
                      title="선택"
                      @click="onSelectEvent('I_PROD_TYP', item)"
                    >
                      <span>{{ item.name }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="btnSearch(true)">
            <span class="hide">검색</span>
          </button>
        </div>
        <p class="inpInfo">조회기간은 현재 월로부터 과거 5년만 가능합니다.</p>

        <h3 class="conTit">조회결과</h3>
        <div class="tabStyle2">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="*" />
              <col width="240" />
              <col width="240" />
              <col width="240" />
              <col width="240" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62">기간</th>
                <th scope="col">종목</th>
                <th scope="col">환종</th>
                <th scope="col">건수</th>
                <th scope="col">보험료</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(d, index) in searchResult"
                :key="index"
                :class="getCellColor(d, index)"
              >
                <td height="74">{{ d.prdDiv }}</td>
                <td>{{ d.insItms }}</td>
                <td>{{ d.curCd }}</td>
                <td>{{ d.cnt }}</td>
                <td>{{ d.curPrem }}</td>
              </tr>
              <tr
                v-if="searchResult.length == 0 && searchResult.length == null"
              >
                <td colspan="5">
                  <p class="noData">조회된 결과가 없습니다.</p>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 더보기 없을떄 삭제 영역 [s] -->
          <!-- <button v-if="searchResult.length != 0" type="button" class="btnMore">
            <span>더보기</span>
          </button> -->
          <!-- 더보기 없을떄 삭제 영역 [e] -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  onBeforeMount,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import _ from "lodash";
import * as codeList from "@/common/code";

const axios = inject("axios");
let now = new Date();
const pastNowTime = util.formatDate(
  new Date(now.setMonth(now.getMonth() - 6)),
  "yyyymm"
);
const nowTime = util.formatDate(new Date(), "yyyymm");

const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");

let I_FR_YM = ref(null);
let I_TO_YM = ref(null);
let searchResult = ref([]);

const state = reactive({
  getIprodType: [], //보험 종목
  ResultTotal: {}, //조회 결과
  I_PROD_TYP: "",
  count: -1,
});

//페이지 진입시
onMounted(async () => {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  I_FR_YM.value = pastNowTime; //시작일
  I_TO_YM.value = nowTime; //종료일
  btnSearch(true);
});

const onSelectEvent = (selectId, data) => {
  if (selectId == "I_PROD_TYP") {
    state.I_PROD_TYP = data.code;
  }
};

//기간 조회
const onChangeInpdt = () => {
  util.getDay(I_FR_YM.value.replace(/-/g, ""), I_TO_YM.value.replace(/-/g, ""));
};

//조회
const btnSearch = async (reset) => {
  if (reset) {
    searchResult.value = [];
  }
  let param = {
    inqStMm: I_FR_YM.value.replace(/-/g, ""),
    inqEdMm: I_TO_YM.value.replace(/-/g, ""),
    salPdCd: state.I_PROD_TYP,
    polhdId: sessionUserInfo.slzCusInf.cusNo, //"10001326596"
  };
  let Result = await axios.transaction("FNGCTNFO0198", param);
  searchResult.value = searchResult.value.concat(
    _.flatten([Result.body?.cargInetSticInqRslInfBcVo || Result.body])
  );
};

//검색 엔터
const keydownHandler = (e) => {
  if (e.keyCode == "13") {
    btnSearch(true);
  }
};

//시작일 키업
const StartKeyUpHandler = (e) => {
  let keyCode = e.which;
  let ignoreKeyCodes =
    ",9,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,46,144,145,";
  if (!util.isNumeric(I_FR_YM.value)) {
    I_FR_YM.value = "";
    swalAlert("숫자만 입력 가능합니다. YYYYMM 형식으로 입력하세요");
  }
  if (ignoreKeyCodes.indexOf("," + keyCode + ",") > -1) {
    return;
  }
  if (keyCode == 8 && event.type == "keydown") {
    return;
  }
  if (I_FR_YM.value.length == 6) {
    let frYy = I_FR_YM.value.substring(0, 4);
    let enYy = I_TO_YM.value.substring(0, 4);
    let frMm = I_FR_YM.value.substring(4);

    if(enYy - frYy > 5){
      swalAlert("조회기간은 최장 5년 입니다.");
      return;
    }
    if (frYy < 1900 || frYy > 2100) {
      I_FR_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    } else if (frMm > 12) {
      I_FR_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    } else if (parseInt(I_FR_YM.value) > parseInt(I_TO_YM.value)) {
      I_FR_YM.value = "";
      swalAlert("[조회 종료월]보다 더 작은 값을 입력하세요");
    } else {
      EndKeyUpHandler();
    }
  }
};

// 종료일 키업
const EndKeyUpHandler = (e) => {
  let keyCode = e.which;
  let ignoreKeyCodes =
    ",9,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,46,144,145,";
  if (!util.isNumeric(I_TO_YM.value)) {
    I_TO_YM.value = "";
    swalAlert("숫자만 입력 가능합니다. YYYYMM 형식으로 입력하세요");
  }
  if (ignoreKeyCodes.indexOf("," + keyCode + ",") > -1) {
    return;
  }
  if (keyCode == 8 && event.type == "keydown") {
    return;
  }
  if (I_TO_YM.value.length == 6) {
    let frYy = I_TO_YM.value.substring(0, 4);
    let frMm = I_TO_YM.value.substring(4);

    if (frYy < 1900 || frYy > 2100) {
      I_TO_YM.value = "";
      swalAlert("조회종기가 적절하지 않습니다.");
      return;
    } else if (frMm > 12) {
      I_TO_YM.value = "";
      swalAlert("조회종기가 적절하지 않습니다.");
      return;
    }
  }
};

const getCellColor = (vo, index) => {
  if (searchResult.value.length - 1 == index) {
    return "bgcolor3";
  } else if (vo.prem > 1 && index % 2 == 0) {
    return "bgcolor1";
  } else if (vo.prem > 1 && index % 2 != 0) {
    return "bgcolor2";
  } else {
    return "bgcolor";
  }
};

init();

async function init() {
  state.getIprodType = codeList.getIprodType;
  axios.json('/logHisLdg.do', {memo:"월별 계약 현황" ,page:window.location.hash});
}
</script>

<style>
.bgcolor {
  background: #dec089;
}
.bgcolor1 {
  background: #fff;
}
.bgcolor2 {
  background: #eee;
}
.bgcolor3 {
  background: silver;
}
</style>
